let isProgrammaticFlag = false;
let autoExpireTimer: ReturnType<typeof setTimeout> | null = null;

export const CoveoHistoryManager = {
  /**
   * Consumes and returns the flag state.
   * Resets the flag to false immediately so subsequent updates default to pushState.
   */
  consume: (): boolean => {
    const wasProgrammatic = isProgrammaticFlag;
    isProgrammaticFlag = false;

    if (autoExpireTimer) {
      clearTimeout(autoExpireTimer);
      autoExpireTimer = null;
    }

    return wasProgrammatic;
  },

  /**
   * Sets the programmatic flag to true.
   * Keeps the flag active across Coveo's deferred microtasks,
   * with a 150ms safety timer in case Coveo doesn't trigger a URL change.
   */
  executeSilently: <T>(action: () => T): T => {
    isProgrammaticFlag = true;

    if (autoExpireTimer) {
      clearTimeout(autoExpireTimer);
    }

    // Safety fallback: auto-clear if no URL update occurs
    autoExpireTimer = setTimeout(() => {
      isProgrammaticFlag = false;
      autoExpireTimer = null;
    }, 150);

    return action();
  },
};
